import { Editor, Element, Transforms } from 'slate';
import * as serializer from 'basic-editor-value-serializer';

const icon = serializer.utilities.node.icon;

function withIcon(editor) {
  const normalizeNode = editor.normalizeNode;
  editor.normalizeNode = function normalizeIcon(entry) {
    const node = entry[0];
    const path = entry[1];
    if (Element.isElement(node) === true) {
      const settings = icon.readSettings(node);
      if (settings !== null && JSON.stringify(settings) !== JSON.stringify(node.properties && node.properties.icon)) {
        Transforms.setNodes(editor, { properties: { ...node.properties, icon: settings } }, { at: path });
        return;
      }
      if (node.type === serializer.types.ICON && JSON.stringify(node.children) !== '[{"text":""}]') {
        Editor.withoutNormalizing(editor, function replaceChildren() {
          for (let index = node.children.length - 1; index >= 0; index--) {
            Transforms.removeNodes(editor, { at: path.concat(index), voids: true });
          }
          Transforms.insertNodes(editor, { text: '' }, { at: path.concat(0), voids: true });
        });
        return;
      }
    }
    normalizeNode(entry);
  };
  return editor;
}

export default withIcon;
